import { isMockingEnabled, handleMockRequest } from '../mocks/mockUtils';

let showTokenExpiredModal: (() => void) | null = null;

export function setTokenExpiredHandler(handler: () => void) {
  showTokenExpiredModal = handler;
}

export async function customFetch(input: RequestInfo, init: RequestInit = {}) {
  const url = typeof input === 'string' ? input : input.url;
  const method = init.method || 'GET';
  
  // Check if mocking is enabled and handle mock request
  console.log('isMockingEnabled', isMockingEnabled());
  if (isMockingEnabled()) {
    const mockResponse = await handleMockRequest(url, method, init);
    if (mockResponse) {
      return mockResponse;
    }
  }

  // Proceed with real request
  const cacheBustingHeaders = {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0',
  };

  const response = await fetch(input, {
    headers: {
      ...cacheBustingHeaders,
      ...init.headers || {},
    }, 
    ...init,
  });

  // Try to parse JSON
  let data;
  try {
    data = await response.clone().json();
  } catch {
    return response;
  }

  if (
    data &&
    data.statusCode === 401 &&
    ["Token expired", "Unauthorized"].includes(data.message) &&
    showTokenExpiredModal
  ) {
    showTokenExpiredModal();
  }

  return response;
} 